<template>
  <div>
    <div class="ml-nav no_padding">
      <div class="center-wrap clearfix">
        <a class="ml-logo">
          <img src="../../assets/images/logo.png" />
        </a>
        <!-- 导航 -->
        <ul class="ml-link">
          <li>
            <!-- <a href="index.html">首页</a> -->
            <router-link
              :to="{ name: 'Home'}"
              :class="{ 'clickMenuNumTrue': $route.meta.active === 'Home'}"
            >首页</router-link>
            <div style="background: #fff"></div>
          </li>
          <li>
            <router-link
              :to="{ name: 'coreTechnology'} "
              :class="{ 'clickMenuNumTrue': $route.meta.active === 'coreTechnology'}"
            >核心技术</router-link>
            <div style="background: #fff"></div>
          </li>
          <li>
            <a
              href="javascript:;"
              :class="{ 'clickMenuNumTrue':$route.meta.active === 'Solution'}"
            >产品与方案</a>
            <div style="background: #fff"></div>
            <ul class="dropdown">
              <li>
                <router-link :to="{ name: 'SoundSafe'}">晟密&nbsp;&nbsp;远程身份验证</router-link>
                <!-- <a href="sm.html">晟密系列</a> -->
              </li>
              <li>
                <router-link :to="{ name: 'SoundDetect'}">晟觉&nbsp;&nbsp;声纹库及搜索比对系统</router-link>
                <!-- <a href="hs.html">绘晟系列</a> -->
              </li>
              <li>
                <router-link :to="{ name: 'SoundScriber'}">晟觉&nbsp;&nbsp;音频数据智能分析系统</router-link>
                <!-- <a href="hs.html">绘晟系列</a> -->
              </li>
              <li>
                <router-link :to="{ name: 'SoundDenoise'}">如晟&nbsp;&nbsp; 语音降噪与增强系统</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'SoundCapture'}">晟觉&nbsp;&nbsp;语音采集工作站</router-link>
                <!-- <a href="rs.html">如晟系列</a> -->
              </li>
              <li>
                <router-link :to="{ name: 'SoundMeeting'}">绘晟&nbsp;&nbsp;多模态智能会议协作系统</router-link>
                <!-- <a href="rs.html">如晟系列</a> -->
              </li>
            </ul>
          </li>
          <!-- 云服务和产品体验中心注释 -->
          <!-- <li><a href="javascript:;" >产品体验</a><div style="background: #fff"></div>
        <ul class="dropdown" style="height: 92px">
                <li><a href="experience.html">开发者指南</a></li>
                <li><a href="form.html">体验中心</a></li>
              </ul>
      </li>
          <li><a href="javascript:;" >云服务</a><div style="background: #fff"></div></li>-->
          <li>
            <!-- <a href="form.html">产品体验</a> -->
            <router-link
              :to="{ name: 'experienceCenter'}"
              :class="{ 'clickMenuNumTrue':$route.meta.active === 'experienceCenter'}"
            >产品体验</router-link>
            <div style="background: #fff"></div>
          </li>
          <li>
            <a
              href="javascript:;"
              :class="{ 'clickMenuNumTrue':$route.meta.active === 'aboutus'}"
            >关于我们</a>
            <div style="background: #fff"></div>
            <ul class="dropdown2">
              <li>
                <router-link :to="{ name: 'joinus'}">招聘</router-link>
                <!-- <a href="sm.html">晟密系列</a> -->
              </li>
              <li>
                <router-link :to="{ name: 'introduction'}">公司介绍</router-link>
                <!-- <a href="hs.html">绘晟系列</a> -->
              </li>
            </ul>
            <!-- <router-link :to="{ name: 'joinus'}">关于我们</router-link> -->
            <!-- <a href="joinus.html">关于我们</a> -->
            <div style="background: #fff"></div>
          </li>
        </ul>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // clickMenuNum: -1
    }
  },
  methods: {
    // doMemuActive (toRouter) {
    //   if (toRouter && toRouter.meta && toRouter.meta.routerParent) {
    //     if (toRouter.meta.routerParent === 'Solution') {
    //       console.log(toRouter.meta.routerParent)
    //       this.clickMenuNum = 5
    //     } else if (toRouter.meta.routerParent === 'intel') {
    //       this.clickMenuNum = 6
    //     } else {
    //       this.clickMenuNum = -1
    //     }
    //   } else {
    //     this.clickMenuNum = -1
    //   }
    // }
  }
  // watch: {
  //   '$route' (toRouter, fromRouter) {
  //     this.doMemuActive(toRouter)
  //   }
  // }
}
</script>

<style  scoped>
.clickMenuNumTrue {
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
}
.clickMenuNumTrue + div {
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
}
.center-wrap {
  position: relative;
  z-index: 1;
  width: 979px;
  height: 100%;
  margin: 0 auto;
  min-width: 979px;
}
.dropdown {
  position: absolute;
  display: none;
  width: 285px;
  padding: 25px;
  height: 220px;
  /* height: 150px; */
  background: rgba(27, 27, 27, 1);
  border-radius: 10px;
  padding-top: 24px;
  top: 24px;
  left: -30px;
}
.dropdown li {
  text-align: left;
  width: 600px;
}
.dropdown2 {
  position: absolute;
  display: none;
  width: 151px;
  height: 95px;
  background: rgba(27, 27, 27, 1);
  border-radius: 10px;
  padding-top: 24px;
  top: 24px;
  left: -30px;
}

.dropdown2 li {
  display: block;
  float: none;
  margin: 0;
}
.dropdown2 li a {
  font-size: 16px !important;
  font-weight: 400;
  color: rgba(166, 166, 166, 1);
  line-height: 15px;
}
.ml-link li:hover .dropdown2 {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue